import { HeadersType, HttpMethod, PayloadRequest, Request } from './api.types';

export const POST: HttpMethod = 'POST';
export function getHttpPostOptions(data: unknown, headers?: HeadersType): PayloadRequest {
  return {
    method: POST,
    data,
    headers
  };
}

export const PUT: HttpMethod = 'PUT';
export const getHttpPutOptions = (data: unknown, headers?: HeadersType): PayloadRequest => ({
  method: PUT,
  data,
  headers
});

export const PATCH: HttpMethod = 'PATCH';
export const getHttpPatchOptions = (data: unknown, headers?: HeadersType): PayloadRequest => ({
  method: PATCH,
  data,
  headers
});

export const GET: HttpMethod = 'GET';
export const getHttpGetOptions = (headers?: HeadersType): Request => ({
  method: GET,
  headers
});

export const DELETE: HttpMethod = 'DELETE';
export const getHttpDeleteOptions = (headers?: HeadersType): Request => ({
  method: DELETE,
  headers
});
